<template>
	<section>
        <div class="no-wrap has-background-white" style="width:100%">
            <div class="columns">
                <div class="column is-12">
                    <b-tabs v-model="activeTab" @change="loadTab">
                        <b-tab-item label="View Firms">
            				<firm-firm />
                        </b-tab-item>
                        <b-tab-item label="View Ex">
                        </b-tab-item>
                    </b-tabs>
                </div>
            </div>
        </div>
	</section>
</template>
<script>
import { tabsMixin } from "@/mixins/tabsMixin";
import FirmFirm from './FirmFirm'
export default {
	components: { FirmFirm },
    mixins: [tabsMixin],
    data: () => ({
        activeTab: 0,
    })
};
</script>



// WEBPACK FOOTER //
// src/components/View/index.vue